






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ListTags from "./listtags";

@Component({
  name: "ui-tags"
})
export default class UiTagsComponent extends Vue {
  @Prop({ default: () => {}, type: Array })
  Items!: Array<ListTags>;
  @Prop({ default: true, type: Boolean })
  edit: Boolean;

  close(value: ListTags) {
    console.log("ui-tags  close");
    value.Selected = false;
    this.$emit("close", value);
  }

  //   mounted() {
  //      this.$children.forEach(item => item.$on("close",this.close))
  //   }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tags/src/ui-tags.vue